module.exports = (__parcel__import__("65Z9a")).then(() => parcelRequire('fyWP3'));